import React from 'react'
import './additional-info.css'
import { HiInformationCircle } from "react-icons/hi";

const AdditionalInfo = () => {

    return (

        <button className="additional-info-card">

            <div className="icon">
                <HiInformationCircle />
            </div>

            <div className="content">
                <p className='description app-text'>Segunda a Sexta</p>
                <p className='description app-text'><b>09:00 às 19:00</b></p>
            </div>

        </button>
    )
}

export default AdditionalInfo